var _circle, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 768 768",
    role: "img",
    "aria-label": "AI",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 384,
    r: 325,
    fill: "#000"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 384,
    y: 478,
    fill: "#fff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 260,
    fontWeight: 700,
    textAnchor: "middle"
  }, "AI")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAi);
export default __webpack_public_path__ + "static/media/icon_ai.9945b736d3464548c6e5295d4da41af0.svg";
export { ForwardRef as ReactComponent };